module.exports = __webpack_public_path__ + "img/newBen-icon-gift.dab3c159.svg";